import { Table } from "reactstrap"
import { useParams } from "react-router-dom"
import moment from "moment"
import useData from "./data"
import { calculateExpenseByEachUser, getBgClassByAmount } from "../../utils/expense"
import ExpensesDistribution from "./Components/ExpenseDistribution"

export default function ExpenseGroup() {
  const { id } = useParams()
  const { group, expenses } = useData(id)
  const { name, description } = group

  const expensesByEachUser = calculateExpenseByEachUser(expenses)

  const maxLength = 15;

  function addWhiteSpace(content) {
    if (content.length > maxLength) {
      let modifiedContent = "";
      for (let i = 0; i < content.length; i += maxLength) {
        modifiedContent += content.slice(i, i + maxLength) + '- ';
      }
      return modifiedContent.replace(/- $/, '');
    }
    return content;
  }

  return (
    <div className="p-2">
      <h4 className="text-muted">{name}</h4>
      <p>{description}</p>

      <Table className="mt-4">
        <thead>
          <tr>
            <th>

              <i className="bx bx-list-check"></i>

            </th>
            <th>
              <i className="bx bx-calendar"></i>
            </th>
            <th>
              <i className="bx bx-dollar"></i>
            </th>
            <th>
              <i className="bx bx-user"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          {expenses.map((expense) => (
            <tr key={expense.id}>
              <td style={{ width: "150px" }}>{addWhiteSpace(expense.title)} </td>
              <td>{moment(expense.created_at).format("MMM DD")}</td>
              <td
                className="p-2 text-white"
                style={{ backgroundColor: getBgClassByAmount(expense.amount) }}
              >{expense.amount}</td>
              <td>{expense.user.username}</td>
            </tr>
          ))}

          {expenses.length === 0 && (
            <tr>
              <td colSpan={3} className="text-center">
                No expenses found
              </td>
            </tr>
          )}

          <tr>
            <td colSpan={2} className="text-right">
              Total
            </td>
            <td>
              {expenses.reduce((total, expense) => total + expense.amount, 0)}
            </td>
          </tr>
        </tbody>
      </Table>

      <h5 className="text-muted mt-4 mb-2">Expense by each user</h5>
      <Table>
        <thead>
          <tr>
            <th>
              <i className="bx bx-user"></i>
            </th>
            <th>
              <i className="bx bx-dollar"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          {expensesByEachUser.map((expense) => (
            <tr key={expense.user.id}>
              <td>{expense.user.username}</td>
              <td>{expense.total}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <ExpensesDistribution expensesByEachUser={expensesByEachUser} />


      {
        moment().isAfter(moment(group.created_at).add(30, "days")) && (
          <div className="alert alert-info">
            This group is expired! <br /> You have reached the end of the month
          </div>
        )
      }


    </div>
  )
}
